import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  groups: [],
  group: {},
  groupIds: [],
};

export const getGroups = createAsyncThunk('groups/getGroups', async () => {
  const { data } = await api.get('/accounts/groups');

  return data;
});

export const getGroupIds = createAsyncThunk('groups/getGroupIds', async () => {
  const { data } = await api.get('/accounts/groups/ids');

  return data;
});

export const getGroup = createAsyncThunk('groups/getGroup', async id => {
  const { data } = await api.get(`/accounts/groups/${id}`);

  return data;
});

export const addGroup = createAsyncThunk('groups/addGroup', async data => {
  const { data: group } = await api.post('/accounts/groups', data);

  return group;
});

export const editGroup = createAsyncThunk(
  'groups/editGroup',
  async ({ id, data }) => {
    const { data: group } = await api.put(`/accounts/groups/${id}`, data);

    return group;
  },
);

const groups = createSlice({
  name: 'groups',

  initialState,

  reducers: {
    clearGroups: draft => {
      draft.groups = initialState.groups;
    },

    clearGroup: draft => {
      draft.group = initialState.group;
    },

    clearGroupIds: draft => {
      draft.groupIds = initialState.groupIds;
    },
  },

  extraReducers: builder => {
    builder.addCase(getGroups.fulfilled, (draft, { payload }) => {
      draft.groups = payload;
    });

    builder.addCase(getGroup.fulfilled, (draft, { payload }) => {
      draft.group = payload;
    });

    builder.addCase(addGroup.fulfilled, (draft, { payload }) => {
      draft.groups.push(payload);
    });

    builder.addCase(editGroup.fulfilled, (draft, { payload }) => {
      const index = draft.groups.findIndex(el => el.id === payload.id);

      draft.groups[index] = payload;
    });

    builder.addCase(getGroupIds.fulfilled, (draft, { payload }) => {
      draft.groupIds = payload;
    });

    builder.addMatcher(
      isAnyOf(
        getGroups.rejected,
        getGroup.rejected,
        addGroup.rejected,
        editGroup.rejected,
        getGroupIds.rejected,
      ),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearGroups, clearGroup, clearGroupIds } = groups.actions;

export default groups.reducer;
